import { render, staticRenderFns } from "./DadosGeraisVisualizacao.vue?vue&type=template&id=8ceed406&scoped=true"
import script from "./DadosGeraisVisualizacao.vue?vue&type=script&lang=js"
export * from "./DadosGeraisVisualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ceed406",
  null
  
)

export default component.exports